enum PreviewFeature {
  AUTOMATION_ALL_USERS = 'automation-all-users',
  EXCLUDE_IPIMS_FOR_ALL_USERS = 'exclude-ipims-for-all-users',
  EXCLUDE_IPIMS_FOR_NON_ADMIN_USERS = 'exclude-ipims-for-non-admin-users',
  EXCLUDE_IVM_PLATFORM_LOGIN = 'exclude-ivm-platform-login',
  INFRASTRUCTURE = 'infrastructure',
  SITES = 'include-site-info',
  TAGS = 'include-tag-info',
}

export default PreviewFeature;
